<template>
    <div class="modal-mask modal-mask--active">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div style="height: 200px;">
            Modal here
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'Modal',

    props: {
      persistent: Boolean,
      overlay: Boolean,
      maxWidth: {
        type: [String, Number],
        default: 'none'
      },
      origin: {
        type: String,
        default: 'center center'
      },
      width: {
        type: [String, Number],
        default: 'auto'
      }
    }
  };
</script>

<style scoped lang="scss">
  .modal {
    &-mask {
      z-index: 9998;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #212121;;
      display: table;
      transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition-delay: 150ms;
      opacity: 0;

      &--active {
        opacity: 0.46;
      }
    }

    &-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    &-container {
      max-height: 90%;
      width: 300px;
      margin: 0 auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
      overflow-y: auto;
      pointer-events: auto;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      z-index: inherit;
    }
  }
</style>
